<template>
  <div class="page-wrapper storybook-cnc-badge-dot">
    <StorybookTemplate title="CncPagination" pathComponent="/shared/elements/global/v1/CncPagination.vue" :propList="propList" :form.sync="form">
      <CncPagination v-bind="form">{{ form.name }}</CncPagination>
    </StorybookTemplate>
  </div>
</template>

<script>
export default {
  components: {
    StorybookTemplate: () => import('../../../../components/StorybookTemplate.vue')
  },
  data () {
    return {
      propList: [
        // { name: 'showLess', type: 'boolean', param: 'showLess' },
      ],

      form: {
        pagination: {
          currentPage: 1,
          key: 2,
          pageSize: 24,
          totalItem: 50
        },
        showLess: false
      }
    }
  }
}
</script>
